// these represent the artifact entity types
export enum ArtifactEntityType {
  ADDRESS = 'address',
  ALPHANUMERIC = 'alphanumeric',
  DATE = 'date',
  EMAIL = 'email',
  NUMERIC = 'numeric',
  PHONE_NUMBER = 'phone_number',
  TIME = 'time',
  ENUM = 'enum',
  CURRENCY = 'currency',
  QUANTITY = 'quantity',
  NAME = 'name',
  FREE_TEXT = 'free_text',
}

// these represent the snapshot entity types
export { EntityType } from '@polyai/schemas';

export enum NumericType {
  INT = 'int',
  FLOAT = 'float',
}

export enum AlphanumericValidationType {
  ZIP_CODE = 'zip_code',
  POSTAL_CODE = 'postal_code',
  CUSTOM = 'custom',
}

export enum AlphanumericRegex {
  US_ZIP_CODE = '^\\d{5}(?:-\\d{4})?$',
  UK_POSTAL_CODE = '^(GIRs?0AA|[A-PR-UWYZ][0-9][0-9]?[A-Z]?|[A-PR-UWYZ][A-HK-Y][0-9][0-9]?[A-Z]?|[A-PR-UWYZ][0-9][A-HJKPSTUW]|[A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRVWXY])s?[0-9][ABD-HJLNP-UW-Z]{2}$',
}

export type EntityReferences = 'flowSteps' | 'noCodeSteps';
